<div class="app-page">
  <div class="app-page-content">
    <section class="app-card">
      <header class="mb-6">
        <div class="flex items-center gap-3 mb-2">
          <button
            pButton
            type="button"
            icon="pi pi-arrow-left"
            class="p-button-text p-button-sm"
            (click)="onCancel()">
          </button>
          <h1 class="section-title">{{ pageTitle }}</h1>
        </div>
        <p class="section-subtitle">
          {{ isEditMode() ? 'Modifica los datos de la ubicación digital' : 'Completa los datos de la nueva ubicación digital' }}
        </p>
      </header>

      <form [formGroup]="ubicacionForm" (ngSubmit)="onSubmit()">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="flex flex-col gap-2">
            <label for="codigo" class="font-medium text-sm">
              Código <span class="text-red-500">*</span>
            </label>
            <input
              id="codigo"
              type="text"
              pInputText
              formControlName="codigo"
              placeholder="Ingrese el código de la ubicación"
              class="w-full"
              [class.ng-invalid]="ubicacionForm.get('codigo')?.invalid && ubicacionForm.get('codigo')?.touched"
            />
            <small
              *ngIf="ubicacionForm.get('codigo')?.invalid && ubicacionForm.get('codigo')?.touched"
              class="text-red-500">
              El código es requerido
            </small>
          </div>

          <div class="flex flex-col gap-2">
            <label for="nombre" class="font-medium text-sm">
              Nombre <span class="text-red-500">*</span>
            </label>
            <input
              id="nombre"
              type="text"
              pInputText
              formControlName="nombre"
              placeholder="Ingrese el nombre de la ubicación"
              class="w-full"
              [class.ng-invalid]="ubicacionForm.get('nombre')?.invalid && ubicacionForm.get('nombre')?.touched"
            />
            <small
              *ngIf="ubicacionForm.get('nombre')?.invalid && ubicacionForm.get('nombre')?.touched"
              class="text-red-500">
              El nombre es requerido
            </small>
          </div>

          <div class="flex flex-col gap-2">
            <label for="canal" class="font-medium text-sm">
              Canal
            </label>
            <p-select
              id="canal"
              formControlName="canal"
              [options]="canalOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleccionar canal"
              [appendTo]="'body'"
              class="w-full">
            </p-select>
          </div>

          <div class="flex flex-col gap-2 md:col-span-2">
            <label for="descripcion" class="font-medium text-sm">
              Descripción
            </label>
            <textarea
              id="descripcion"
              pTextarea
              formControlName="descripcion"
              placeholder="Describe la ubicación (opcional)"
              rows="3"
              class="w-full">
            </textarea>
          </div>

          <div class="flex flex-col gap-2">
            <label for="active" class="font-medium text-sm">
              Estado
            </label>
            <div class="flex items-center gap-3">
              <p-toggleSwitch
                id="active"
                formControlName="active">
              </p-toggleSwitch>
              <span class="text-sm text-muted">
                {{ ubicacionForm.get('active')?.value ? 'Activo' : 'Inactive' }}
              </span>
            </div>
          </div>
        </div>

        <div class="flex items-center gap-3 mt-8 pt-6 border-t border-border">
          <button
            pButton
            type="submit"
            [label]="isEditMode() ? 'Actualizar' : 'Crear'"
            icon="pi pi-check"
            class="p-button-sm"
            [disabled]="loading() || ubicacionForm.invalid">
          </button>
          <button
            pButton
            type="button"
            label="Cancelar"
            icon="pi pi-times"
            class="p-button-outlined p-button-sm"
            (click)="onCancel()"
            [disabled]="loading()">
          </button>
        </div>
      </form>
    </section>
  </div>
</div>
